import { ref, reactive, computed } from 'vue'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const PHONE_MIN_LENGTH = 9

export function useValidation() {
  const validation = reactive({
    firstname: { error: false, message: '' },
    lastname: { error: false, message: '' },
    email: { error: false, message: '' },
    cellphone: { error: false, message: '' }
  })

  const validateField = (field, value, rules = {}) => {
    validation[field].error = false
    validation[field].message = ''

    if (rules.required && (!value || value.trim() === '')) {
      validation[field].error = true
      validation[field].message = `${field} es requerido`
      return false
    }

    if (field === 'email' && value) {
      if (!EMAIL_REGEX.test(value)) {
        validation[field].error = true
        validation[field].message = 'El formato del email no es válido'
        return false
      }
    }

    if (field === 'cellphone' && value) {
      if (value.length < PHONE_MIN_LENGTH) {
        validation[field].error = true
        validation[field].message = `El número debe tener al menos ${PHONE_MIN_LENGTH} dígitos`
        return false
      }
    }

    return true
  }

  const validateForm = (formData, rules = {}) => {
    let isValid = true

    Object.keys(validation).forEach(field => {
      if (formData.hasOwnProperty(field)) {
        const fieldValid = validateField(field, formData[field], rules[field] || {})
        if (!fieldValid) isValid = false
      }
    })

    return isValid
  }

  const setServerErrors = (errors) => {
    Object.keys(validation).forEach(field => {
      if (errors[field]) {
        validation[field].error = true
        validation[field].message = Array.isArray(errors[field]) 
          ? errors[field][0] 
          : errors[field]
      }
    })
  }

  const clearValidation = () => {
    Object.keys(validation).forEach(field => {
      validation[field].error = false
      validation[field].message = ''
    })
  }

  const isFormValid = computed(() => {
    return !Object.values(validation).some(field => field.error)
  })

  return {
    validation,
    validateField,
    validateForm,
    setServerErrors,
    clearValidation,
    isFormValid,
    EMAIL_REGEX,
    PHONE_MIN_LENGTH
  }
}